import React, { useState, useEffect } from 'react'
import { CHECK_COMPANY_TENANT, MICROMONEY_LIKE } from '../../../../../../../layouts/MainTenantconfig';
import { getUrlApi, saveAgreegatorDataApi } from '../../../../actioncreatormarketing';
import Popup from '../../../../../../presentationals/Popup/Popup.component'
export default function Registration({ handleSave, setSaveHandler, setLoader }) {
    const [urlToDisplay, setUrl] = useState('')
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [objectData, setObjectData] = useState({
        aggregatorType: "",
        aggregatorName: "",
        partnerName: "",
        // campaignName: "",
        organizationContactNumber: "",
        pocName: "",
        pocEmail: "",
        pocNumber: "",
        websiteLink: "",
        creatorMode: "",
        status: "",
        uploadLogoUrl: ""

    })

    const handleUrls = (e) => {
        if (e && e.target.files) {
            setLoader(true)
            let type = e.target.files[0].type === 'application/pdf' ? 'pdf' : 'img'

            getUrlApi(e.target.files[0], e.target.files[0].name, type, callback => {
                if (callback) {
                    let changeData = Object.assign({}, objectData)
                    changeData['uploadLogoUrl'] = callback
                    setObjectData(changeData)
                    setUrl(callback.includes(`//test.${tenant?.ADMIN_URL_STRING_SHORT}`) ? callback.replace(`//test.${tenant?.ADMIN_URL_STRING_SHORT}`, `//testbackend.${tenant?.ADMIN_URL_STRING_SHORT}`) : callback.replace(`//${tenant?.ADMIN_URL_STRING_SHORT_FULL_URL}`, `//${tenant?.ADMIN_URL_STRING_SHORT_FULL_URL}`))
                    setLoader(false)
                }
            })
        }
    }

    const handleChange = (e, type) => {
        const { value } = e.target;
        setObjectData((prev) => ({
            ...prev,
            [type]: value
        }))
    }

    useEffect(() => {
        setSaveHandler(() => saveRegistration);
    }, [objectData]);

    const saveRegistration = async () => {
        console.log("Saving data:", objectData);

        const obj = {
            aggregatorType: objectData?.type ?? "",
            companyName: objectData?.aggregatorName ?? "",
            partnerName: objectData?.partnerName ?? "",
            // campaignName: objectData?.campaignName ?? "",
            organizationContactNo: objectData?.organizationContactNumber ?? "",
            contactPerson: objectData?.pocName ?? "",
            email: objectData?.pocEmail ?? "",
            mobileNumber: objectData?.pocNumber ?? "",
            webAddress: objectData?.websiteLink ?? "",
            creatorMode: objectData?.creatorMode ?? "",
            status: objectData?.status ?? "",
            uploadLogoUrl: objectData?.uploadLogoUrl ?? "",
        }

        saveAgreegatorDataApi(obj, callback => {

            if (callback === 'success') {
                setLoader(false)
                setPopup({ show: true, popupStatus: "Data Save Successfully !" })
                removePopup()

            } else {
                setLoader(false)
                setPopup({ show: true, popupStatus: "Please try again later !" })
                removePopup()
            }
        })
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000);
    }

    return (
        <>
            {
                popup?.show ?
                    <Popup closePopup={closePopup} popupStatus={popup?.popupStatus} />
                    : ""
            }
            <div style={{ background: '#fff', borderRadius: '10px', padding: '20px', border: '1px solid #eee', marginTop: '20px' }}>
                <div className="row">
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Aggregator Type</label>
                            <select className='customInput-new' type="text" value={objectData?.aggregatorType} onChange={(e) => handleChange(e, "aggregatorType")} >
                                <option value={""}>Select Option</option>
                                <option value="Digital">Digital</option>
                                <option value="ThirdParty">Third Party</option>
                                <option value="AmbassadorScouts">Ambassador / Scouts</option>
                                <option value="Corporate">Corporate</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Aggregator Name</label>
                            <input className='customInput-new' type="text" value={objectData?.aggregatorName} onChange={(e) => handleChange(e, "aggregatorName")} />
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Partner Name</label>
                            <input className='customInput-new' type="text" value={objectData?.partnerName} onChange={(e) => handleChange(e, "partnerName")} />
                        </div>
                    </div>
                    {/* <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Campaign Name</label>
                            <input className='customInput-new' type="text" value={objectData?.campaignName} onChange={(e) => handleChange(e, "campaignName")} />
                        </div>
                    </div> */}

                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Organisation Contact Number</label>
                            <input className='customInput-new' type="number" value={objectData?.organizationContactNumber} onChange={(e) => handleChange(e, "organizationContactNumber")} />
                        </div>
                    </div>
                </div>
                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">POC Name</label>
                            <input className='customInput-new' type="text" value={objectData?.pocName} onChange={(e) => handleChange(e, "pocName")} />

                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">POC Email</label>
                            <input className='customInput-new' type="email" value={objectData?.pocEmail} onChange={(e) => handleChange(e, "pocEmail")} />
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">POC Mobile Number</label>
                            <input className='customInput-new' type="number" value={objectData?.pocNumber} onChange={(e) => handleChange(e, "pocNumber")} />
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Website Link</label>
                            <input className='customInput-new' type="text" value={objectData?.websiteLink} onChange={(e) => handleChange(e, "websiteLink")} />
                        </div>
                    </div>
                </div>
                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Creator Mode</label>
                            <select className='customInput-new' type="text" value={objectData?.creatorMode} onChange={(e) => handleChange(e, "creatorMode")} >
                                <option value={""}>Select Option</option>
                                <option value="Branch">Branch</option>
                                {
                                    !CHECK_COMPANY_TENANT(MICROMONEY_LIKE) ?
                                        <option value="Singular">Singular</option>
                                        : ''}
                                <option value="Google">Google</option>
                                <option value="System Integration">System Integration</option>
                                <option value="API/ javaScript">API/ javaScript</option>
                                <option value="Social Media">Social Media</option>
                            </select>

                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Status</label>
                            <select className='customInput-new' type="text" value={objectData?.status} onChange={(e) => handleChange(e, "status")} >
                                <option value={""}>Select Option</option>
                                <option value={true}>Active</option>
                                <option value={false}>Inactive</option>
                            </select>

                        </div>
                    </div>

                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box' style={{ marginTop: '20px' }}>
                            <div className="customFileInputBox">
                                <input className='inputbox_file' type='file' accept={[".png", ".jpg", ".jpeg"]} onChange={(e) => handleUrls(e)} />
                                <div className="customTextbox">
                                    Click here to Upload logo
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
